export default () => {
    const calcSticky = () => {
        const stickyHeight = stickyEl.clientHeight
        const offset = 26
        const windowHeight = window.innerHeight

        if (windowHeight > stickyHeight + offset) {
            stickyEl.classList.add('force-sticky')
        } else {
            stickyEl.classList.remove('force-sticky')
        }
    }

    const stickyEl = document.querySelector('.js-sticky-case-study')

    if (stickyEl) {
        calcSticky()

        window.addEventListener('resize', calcSticky)
    }
}
